import { 
  AreaChart, 
  Area, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer 
} from 'recharts';

export default function USDebtChart({ filteredDates, debtSeries, range }) {
  if (!Array.isArray(debtSeries) || debtSeries.length === 0) {
    return (
      <div className="w-full h-96 flex items-center justify-center">
        <div className="text-gray-500">暂无数据</div>
      </div>
    );
  }

  // 转换数据格式
  const chartData = debtSeries.map((item, index) => {
    return {
      date: item.date || (filteredDates && filteredDates[index]) || `期间${index + 1}`,
      內部持有: Number(item.DEBT_INTRA || 0),
      公眾持有: Number(item.DEBT_PUB || 0),
    };
  });

  // 自定义工具提示
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const total = payload.reduce((sum, entry) => sum + (entry.value || 0), 0);
      
      return (
        <div 
          className="p-3 border border-gray-200 rounded-lg shadow-lg text-sm" 
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.9)', // ✅ 強制設為白色，90% 透明
            backdropFilter: 'blur(8px)',                // 模糊效果
            WebkitBackdropFilter: 'blur(8px)'           // 兼容 Safari
          }}
        >
          <p className="font-semibold mb-2 pb-1 border-b border-gray-200">
            {label}
          </p>
          {payload
            .sort((a, b) => b.value - a.value)
            .map((entry, index) => (
            <div key={index} className="flex justify-between items-center min-w-40 mb-1">
              <span style={{ color: entry.color }}>{entry.name}: </span>
              <span className="font-medium ml-2">
                ${entry.value.toFixed(2)}
              </span>
            </div>
          ))}
          <div className="mt-2 pt-1 border-t border-gray-200 font-semibold">
            國債總額: ${total.toFixed(2)}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full" style={{ height: '650px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={chartData}
          margin={{ top: 10, right: 30, left: 40, bottom: 80 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          
          <XAxis 
            dataKey="date"
            tick={{ fontSize: 11 }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          
          <YAxis 
            tick={{ fontSize: 11 }}
            width={60}
          />
          
          <Tooltip content={<CustomTooltip />} />
          
          <Legend 
            wrapperStyle={{ paddingTop: '10px', fontSize: '12px' }}
            iconType="rect"
          />

          <Area 
            type="monotone" 
            dataKey="內部持有" 
            stackId="1" 
            stroke="#8884d8" 
            fill="#8884d8" 
            fillOpacity={0.8}
          />
          <Area 
            type="monotone" 
            dataKey="公眾持有" 
            stackId="1" 
            stroke="#e00505ff" 
            fill="#e00505ff" 
            fillOpacity={0.8}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}